import { useDroppable } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import React from 'react';

const getDropTargetClassName = (baseClassName, isDropTarget, isOver) =>
  [
    baseClassName,
    isDropTarget && 'toy-image-drop-target',
    isDropTarget && isOver && 'toy-image-drop-target-over',
  ]
    .filter(Boolean)
    .join(' ');

export const ImageDropZone = ({ id, disabled, children }) => {
  const { setNodeRef, isOver, active } = useDroppable({
    id,
    data: { list: id },
    disabled,
  });
  const isDropTarget = !!active && active?.data?.current?.list !== id;

  return (
    <div
      ref={setNodeRef}
      className={getDropTargetClassName(
        'toy-image-drop-zone',
        isDropTarget,
        isOver,
      )}
    >
      {children}
      {isDropTarget && isOver && (
        <span className="toy-image-drop-hint">Set as featured</span>
      )}
    </div>
  );
};

const SortableImageItem = ({ id, list, index, disabled, children }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    isOver,
    active,
  } = useSortable({ id, data: { list, index }, disabled });
  // Items in the other list are swap targets; items in the same list just shift
  const isDropTarget =
    !!active && !isDragging && active?.data?.current?.list !== list;

  const style = {
    transform: transform
      ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
      : undefined,
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={getDropTargetClassName(
        [
          'toy-sortable-image',
          !disabled && 'toy-sortable-image-draggable',
          isDragging && 'toy-sortable-image-dragging',
        ]
          .filter(Boolean)
          .join(' '),
        isDropTarget,
        isOver,
      )}
      {...attributes}
      {...listeners}
    >
      {children}
      {isDropTarget && isOver && (
        <span className="toy-image-drop-hint">
          {list === 'featuredImages' ? 'Set as featured' : 'Swap'}
        </span>
      )}
    </div>
  );
};

export default SortableImageItem;
